module.exports = __webpack_public_path__ + "static/media/parts_16.261afceb.svg";